module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-6-thumb.8584fee5.png";